export enum TimelineElementTypes {
	Timeline = "timeline",
	Track = "track",
	Object = "object",
	Channel = "channel",
	Fragment = "timebar",
	ActionTrackFragment = "action",
}

export interface ITimeline
{
	// timelineId: string,
	// stepId: string,
	// sceneId: string,
	fps: number,
	loopTime: number,
	totalTime: number,
	isLoopEnabled: boolean,
	currentTime: number,
	id: string,
	// isRecording: boolean,
	// isPlaying: boolean,
	getType(): TimelineElementTypes;
}

export interface ITimelineChannel extends IReversibleTimelineElement, ITimelineElementParent
{
	object: ITimelineObject,
}

export interface ITimelineObject extends ITimelineElementParent
{

}

export interface ITimelineFragment 
{
	fragmentId: string,
	name: string,
	startTime: number,
	previousTime: number,
	endTime: number,
	effectorType: string,
	timeline?: ITimeline,
	channel: ITimelineChannel,
}

interface ITimelineElementListener 
{
	onAdded(): void;
	onDelete(): void;
}

export interface ITimelineElement extends ITimelineElementListener 
{
	id: string;
	name?: string;
	getType(): TimelineElementTypes;
	getParent(): ITimelineElementParent;
	getName(): string;
	setParent(parent: ITimelineElementParent): void;
}

export interface ITimelineElementParent extends ITimelineElementListener
{
	getName(): string;
	setChildren(children: ITimelineElement[]) : void;
	getChildren(): ITimelineElement[];
}

export interface IReversibleTimelineElement extends ITimelineElement
{
	reverse(): void;
}

export interface IFragmentTimingData 
{
	id: string,
	start: number,
	end: number,
}

export interface ITimelineParentElementPairs 
{
	parent: ITimelineElementParent,
	element: ITimelineElement,
}